import { buildWhatsAppUrl } from "@/i18n";

// Inline WhatsApp logo SVG (official-style glyph in white)
export function WhatsAppGlyph({ className }) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={className}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        d="M16 .5C7.44.5.5 7.44.5 16c0 2.83.74 5.58 2.15 8L0 32l8.27-2.59A15.46 15.46 0 0 0 16 31.5C24.56 31.5 31.5 24.56 31.5 16S24.56.5 16 .5Zm0 28.21c-2.43 0-4.78-.65-6.83-1.88l-.49-.29-4.91 1.54 1.57-4.78-.32-.5A12.7 12.7 0 1 1 28.71 16 12.72 12.72 0 0 1 16 28.71Zm7.34-9.5c-.4-.2-2.38-1.18-2.75-1.31-.37-.13-.64-.2-.91.2-.27.4-1.05 1.31-1.29 1.58-.24.27-.47.3-.87.1-.4-.2-1.7-.62-3.24-2-1.2-1.07-2-2.39-2.24-2.79-.23-.4-.02-.62.18-.82.18-.18.4-.47.6-.7.2-.23.27-.4.4-.67.13-.27.07-.5-.03-.7-.1-.2-.91-2.2-1.25-3.01-.33-.79-.66-.68-.91-.7-.23-.01-.5-.01-.77-.01a1.5 1.5 0 0 0-1.08.5c-.37.4-1.42 1.39-1.42 3.39 0 2 1.45 3.93 1.65 4.2.2.27 2.85 4.35 6.9 6.1.96.42 1.72.67 2.3.86.97.31 1.85.27 2.55.16.78-.12 2.38-.97 2.72-1.91.34-.94.34-1.74.24-1.91-.1-.17-.37-.27-.77-.47Z"
      />
    </svg>
  );
}

export default function WhatsAppButton({ t }) {
  const href = buildWhatsAppUrl(t.whatsapp.prefilled);
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.whatsapp.title}
      data-testid="whatsapp-floating-btn"
      className="group fixed left-5 sm:left-6 z-50 flex items-center gap-3 pl-4 pr-5 h-14 sm:h-16 rounded-full text-white shadow-2xl transition-transform hover:scale-105 active:scale-95"
      style={{
        bottom: "max(1.25rem, env(safe-area-inset-bottom, 1.25rem))",
        backgroundColor: "#25D366",
        boxShadow: "0 12px 30px rgba(37, 211, 102, 0.45)",
      }}
    >
      <WhatsAppGlyph className="w-7 h-7 sm:w-8 sm:h-8" />
      <span className="font-bold text-base hidden sm:inline">
        {t.whatsapp.floating}
      </span>
    </a>
  );
}
